import { Steps as AntdSteps } from 'antd';
import { defaultProps, StepsProps } from './Steps.type';
import styles from "./Steps.module.scss";

export const Steps = (props: StepsProps) => {
  const { stepList, current, currentStepIcon, ...attributes } = { ...defaultProps, ...props };

  return (
    <AntdSteps {...attributes} current={current} className={styles.Steps}>
      {stepList.map((item, index) => (
        <AntdSteps.Step
          key={index}
          title={item.title}
          description={item.description}
          icon={current === index && currentStepIcon && (currentStepIcon)}
        />
      ))}
    </AntdSteps>
  )
};
